import { BUTTON_PRESS } from './baseEvents'

const SEND_TO_ONTIC = 'Send to Ontic'

// Existing production string — kept identical by building off BUTTON_PRESS
export const SEND_TO_ONTIC_BUTTON_PRESS = `${BUTTON_PRESS} ${SEND_TO_ONTIC}`
export const SEND_TO_ONTIC_DISABLED_TOOLTIP_SHOWN = `${SEND_TO_ONTIC} - Disabled Tooltip Shown`
export const SEND_TO_ONTIC_SUCCESS = `${SEND_TO_ONTIC} - Success`
export const SEND_TO_ONTIC_FAILURE = `${SEND_TO_ONTIC} - Failure`
